module.exports = __webpack_public_path__ + "img/img_person4_mobile.6a183299.png";